module.exports = __webpack_public_path__ + "img/云小稼-app下载码.23204294.png";